const updateForceMobileCookie = () => {
  // Consider mobile if width is less than or equal to 1192px as it is when the map change to mobile view
  const isMobile = window.innerWidth <= 1192;
  document.cookie = `force_mobile=${isMobile ? 1 : 0}; path=/`;
}

// Initial call
updateForceMobileCookie();

// Detect changes in real size
window.addEventListener('resize', updateForceMobileCookie);

// Polling to detect changes in DevTools / responsive mode
let lastWidth = window.innerWidth;
setInterval(() => {
  if (window.innerWidth !== lastWidth) {
    lastWidth = window.innerWidth;
    updateForceMobileCookie();
  }
}, 100);

const privacyConsentDuringRegistration = () => {
    const form    = document.getElementById('signupform');
    if (!form) return;

    const checkbox = document.getElementById('privacy_policy');
    const submit   = form.querySelector('input[type="submit"]');

    if (!checkbox || !submit) return;

    const setButtonState = (enabled) => {
        submit.disabled = !enabled;
        if (enabled) {
            submit.style.background = '';
            submit.style.cursor     = '';
            submit.style.opacity    = '';
        } else {
            submit.style.background = 'gray';
            submit.style.cursor     = 'not-allowed';
            submit.style.opacity    = '0.6';
        }
    };

    // Estado inicial
    setButtonState(checkbox.checked);

    // Cambio de estado al marcar/desmarcar
    checkbox.addEventListener('change', function () {
        setButtonState(this.checked);
    });

    // Seguridad extra
    form.addEventListener('submit', function (e) {
        if (!checkbox.checked) {
            e.preventDefault();
        }
    });
}
document.addEventListener('DOMContentLoaded', () => {
    privacyConsentDuringRegistration();
});